<template>
    <v-toolbar  
        flat
		dense		
		:class="`mx-0 px-128 ${scrollTop ? '' : 'menu-fixed-header-top px-128'}`"
		style="z-index:9991"
    >
		<v-row align="center" justify="center">
			<v-col cols="12" md='6' class='mt-10 mt-md-0 text-center text-md-left'>
				<img :src="`${require('@/assets/bandera-header.png')}`" class='icon-social'>
				<a :href="`tel:${dataWeb.phone.split('-')[0]}${dataWeb.phone.split('-')[1]}`" class='text-decoration-none'>
					<img :src="`${require('@/assets/llamada-naranja-header.png')}`"  class='icon-social'> <span class='gray--text font-title'><b><i>({{ dataWeb.phone.split('-')[0] }}) {{ dataWeb.phone.split('-')[1] }}</i></b></span>
				</a>
				<a class='blue--text text-decoration-none' target='_blank' :href="`https://api.whatsapp.com/send?phone=+${dataWeb.telWhatsapp.split('-').join('')}&text=${dataWeb.msgWhatsapp}`">
					<img :src="`${require('@/assets/wapp-naranja-header.png')}`" class='icon-social'> <span class='gray--text font-title'><b><i>({{ dataWeb.telWhatsapp.split('-')[1] }}) {{ dataWeb.telWhatsapp.split('-')[2] }}</i></b></span>
				</a>
			</v-col>
			<v-col cols="12" md='6' class='text-center text-md-right'>
				<a href="/covid19" class='gray--text font-title' style="text-decoration:none;"><b><i>Covid-19</i></b></a>
				<v-divider
					class="mx-1"
					color='silver'
					vertical
				></v-divider>
				<a href="/trabaja-con-nosotros" class='gray--text font-title' style="text-decoration:none;"><b><i>Trabaje con nosotros</i></b></a>
				<a :href="`${ dataWeb.facebook == null ? '#' : dataWeb.facebook}`">
					<img :src="`${require('@/assets/fb-naranja-header.png')}`" class='icon-social'>
				</a>
				<a :href="`${ dataWeb.instagram == null ? '#' : dataWeb.instagram}`">
					<img :src="`${require('@/assets/ig-naranja-header.png')}`" class='icon-social'>
				</a>
				<a :href="`${ dataWeb.twitter == null ? '#' : dataWeb.twitter}`">
					<img :src="`${require('@/assets/tw-naranja-header.png')}`" class='icon-social'>
				</a>
			</v-col>
		</v-row>
    </v-toolbar>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'HeaderTopComponent',
	data:()=>({
       
    }),
	computed:{
        ...mapState(['scrollTop','dataWeb'])
    }
}

</script>

<style scope>
	.icon-social{
		width: 21px;
		position: relative;
		top:5px;
		margin:0 5px
	}
	.v-divider{
		border-color: rgb(192 192 192);
		border: 1px solid silver;
		height: 20px;
	}
	.px-128{
		padding: 0 128px;
	}
	.menu-fixed-header-top{
		z-index: 9991;
		position: fixed;
		width: 100%;
	}
	.v-toolbar__content{
		padding: 0;
	}
</style>
